import type { CheckboxFieldConfig } from '@shared/types/interactiveFields';

type Language = 'bg' | 'de' | 'en';

interface CheckboxFieldProps {
  field: CheckboxFieldConfig;
  value: boolean;
  onChange: (value: boolean) => void;
  error?: string;
  disabled?: boolean;
  language: Language;
}

export function CheckboxField({ field, value, onChange, error, disabled, language }: CheckboxFieldProps) {
  return (
    <div className="flex items-start space-x-3">
      <input
        type="checkbox"
        checked={value || false}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        className="w-4 h-4 mt-1 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
      />
      <div className="space-y-1 flex-1">
        <label className="block text-sm font-medium text-gray-700">
          {field.label[language] || field.label.bg}
          {field.required && <span className="text-red-500 ml-1">*</span>}
        </label>
        {field.helpText && (
          <p className="text-sm text-gray-500">
            {field.helpText[language] || field.helpText.bg}
          </p>
        )}
        {error && <p className="text-sm text-red-500">{error}</p>}
      </div>
    </div>
  );
}
